export default __webpack_public_path__ + "static/media/youtube-light.20dc8352.svg";